module.exports = __webpack_public_path__ + "static/59-270e29a86d34987357a72f4c6b4ecf94.png";